import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '../../../../components/ui/Alert';

interface DeadlineWarningProps {
  month: string;
}

const DeadlineWarning: React.FC<DeadlineWarningProps> = ({ month }) => {
  const { t } = useTranslation();

  return (
    <Alert variant="warning" className="mb-6">
      {t('performance.reflections.deadlineWarningMessage', { month })}
    </Alert>
  );
};

export default DeadlineWarning;
